<template>
  <div class="my-4">
    <label class="subtitle-1 mb-2 d-block font-weight-medium">{{
      label
    }}</label>
    <label v-if="filename" class="subtitle-1 d-block mb-2">
      <span>Current File: </span
      ><span class="font-weight-bold">{{ filename }}</span>
    </label>
    <v-file-input
      v-model="uploadValue"
      label="Select a file to upload..."
      filled
      prepend-icon="mdi-file-outline"
      :rules="rules"
      @change="updateField"
    ></v-file-input>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      uploadValue: null,
    };
  },
  props: {
    file: {
      type: File,
    },
    filename: {
      type: String,
    },
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    updateField() {
      if (!this.uploadValue) return;

      this.$emit("update:file", this.uploadValue);
      this.$emit("update:filename", this.uploadValue.name);
    },
  },
  computed: {
    uploadLabel() {
      return (this.value ? "Replace" : "Upload") + " " + this.field.getLabel();
    },
    url() {
      if (this.value) return this.$renderHelpers.uploadUrl(this.value);
      return false;
    },
  },
});
</script>
